// extracted by mini-css-extract-plugin
module.exports = {"List":"List_List__PoFOH","List_large":"List_List_large__fPyEo","List_columns_2":"List_List_columns_2__FLtT7"};